module.exports = __webpack_public_path__ + "static/media/fruits_48.fdae926b.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_48.csv
// module id = 715
// module chunks = 0